export const composeProtectButton = "f$a";
export const composeSetPermissionDropDown = "g$a";
export default {composeProtectButton,composeSetPermissionDropDown};